import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onFilterToggle }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  const handleClear = () => {
    setSearchQuery('');
    onSearch('');
  };

  return (
    <form onSubmit={handleSearch} className="flex gap-3">
      <div className="flex-1 relative">
        <Input
          type="search"
          placeholder="İsim, kullanıcı adı veya kategori ara..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="pr-10"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-muted rounded transition-smooth"
            aria-label="Aramayı temizle"
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </div>
      <Button
        type="submit"
        variant="default"
        iconName="Search"
        className="hidden sm:flex"
      >
        Ara
      </Button>
      <Button
        type="button"
        variant="outline"
        iconName="SlidersHorizontal"
        onClick={onFilterToggle}
        className="lg:hidden"
      >
        Filtreler
      </Button>
    </form>
  );
};

export default SearchBar;